import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  borderRadius: 'md',
  contain: 'paint',
  boxShadow:
    '0px 4px 8px 0px rgba(0, 0, 0, 0.25), 0px 0px 20px 0px rgba(0, 216, 255, 0.15) inset, 0px 0px 0px 1px rgba(255, 255, 255, 0.05) inset',
  mb: '3',
  border: '0',

  ...(isNested && {
    boxShadow:
      '0px 4px 8px 0px rgba(0, 0, 0, 0.25), 0px 0px 20px 0px rgba(0, 216, 255, 0.15) inset, 0px 0px 0px 1px rgba(255, 255, 255, 0.05) inset',
    mb: '2',
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  border: 0,
  p: '2',
  borderBottomRadius: 'md',
  bg: 'rgba(34, 92, 161, 0.5)',

  ...(isNested && {
    bg: 'rgba(34, 92, 161, 0.5)',
  }),
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'rgba(34, 92, 161, 0.5)',
  color: 'white',
  px: '2',
  py: '2.5',
  borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 'md',
  fontWeight: 'normal',
  fontSize: 'sm',
  fontFamily: 'body',
  display: 'flex',
  justifyContent: 'space-between',

  _hover: {
    bg: 'alpha.500',
  },

  '.chakra-accordion__icon': {
    boxSize: '5',
    color: 'white',
    transition: '.3s ease-in-out',
  },

  _expanded: {
    p: '2',
    borderBottomRadius: 'none',
  },

  ...(isNested && {
    bg: 'rgba(34, 92, 161, 0.5)',
    color: 'white',
    fontWeight: 'normal',
    px: '2',

    _hover: {
      bg: 'alpha.500',
    },

    '.chakra-accordion__icon': {
      boxSize: ['4', '5'],
      transition: '.3s ease-in-out',
    },
  }),
});

export const BoxWrapper: CSSObject = {
  py: '2',
  px: '0',
  borderBottomRadius: '6px',
};
